import React from 'react';
import Navbar from './components/Navbar';
import Visualizer from './components/Visualizer';
//import Visualizer from './components/TestVisual';

const App = () => (
  <div className="container">
    <Navbar />
    <Visualizer />
  </div>
);

export default App;
